import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Keeps the inventory countdown block in sync with the selected variant.
 *
 * Horizon does not re-render the whole product details block when a variant
 * changes - it dispatches a variantUpdate event carrying the freshly rendered
 * section markup. Each block is responsible for morphing itself from that
 * markup, which is what this element does.
 */
class InventoryCountdown extends HTMLElement {
  connectedCallback() {
    this.sectionElement = this.closest('.shopify-section, dialog');
    this.sectionElement?.addEventListener(ThemeEvents.variantUpdate, this.updateCountdown);
  }

  disconnectedCallback() {
    this.sectionElement?.removeEventListener(ThemeEvents.variantUpdate, this.updateCountdown);
  }

  /**
   * @param {CustomEvent} event - The variant update event.
   */
  updateCountdown = (event) => {
    const data = event.detail && event.detail.data;
    if (!data) return;

    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const next = data.html && data.html.querySelector('inventory-countdown');
    if (!next) return;

    morph(this, next, { childrenOnly: true });
  };
}

if (!customElements.get('inventory-countdown')) {
  customElements.define('inventory-countdown', InventoryCountdown);
}